module.exports = "<div style=display:flex;flex-direction:column;justify-content:center;align-items:center> <h1> THIS VIEW IS NO LONGER IN USE</h1> <h2><a href=manager/assessment/round-management/ ><strong> Take me to the new view</strong></a></h2> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-round/performance-review-round.html
 ** module id = 265
 ** module chunks = 0
 **/